// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleFoundationLine_root__1KaUZ","content":"ArticleFoundationLine_content__h3y5Y"};